import { FormattedMessage, injectIntl } from 'react-intl';
import React, {
  useState,
  useContext,
  useRef,
  useEffect,
  useImperativeHandle,
} from 'react';
import { Form, Input, Button, Spin, Row, Col, Modal } from 'antd';
import classnames from 'classnames';
import FloatLabel from '@/components/CardElements/FloatLabel/index.js';

import { qptValidate, qptResend } from '@/components/H5PC/service';
import _ from 'lodash';
import NodeRSA from 'node-rsa';
import myContext from '@/utils/createContext';
import { getUrlParams } from '@/utils/index.js';
import allRegex from '@/components/allRegex.js';
import { getRedirectUrl } from '@/components/CardElements/utils';
import { resCodeMsg } from '@/components/resCodeMsg';

let timeChange;
function MessageModal(props) {
  const intl = props.intl;
  const {
    initData,
    isMobileView,
    isModalVisible,
    setIsModalVisible,
    key,
    msgModalCardNo,
    bankCode,
    loading,
    setLoading,
    validateKey,
    setValidateKey,
    myActualPaymentAmount,
    myActualPaymentCurrencySymbol,
    msgModalPhoneNum,
  } = useContext(myContext);
  // 获取后7位
  let cardNo = '*** ' + msgModalCardNo.substr(-4);
  let { totalCurrencySymbol, totalAmount } = initData || {};

  let phoneNum = msgModalPhoneNum;
  phoneNum = phoneNum ? phoneNum.replace(phoneNum.substring(3, 7), '****') : '';

  const [form] = Form.useForm();
  const [time, setTime] = useState(60);
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [btnContent, setBtnContent] = useState('send');
  const [btnLoading, setBtnLoading] = useState(false); // btnLoading
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(true); // btnLoading
  // const [isModalVisible, setIsModalVisible] = useState(false);
  const [codeNum, setCodeNum] = useState(0);

  useEffect(() => {
    clearInterval(timeChange);
    return () => clearInterval(timeChange);
  }, []);

  useEffect(() => {
    setTime(60);
    setCodeNum(0);
    form.setFieldsValue({ captcha: '' });
    if (isModalVisible === true) {
      startFirst();
    }
  }, [isModalVisible]);

  useEffect(() => {
    if (time > 0 && time < 60) {
      setBtnContent(`${time}s resend`);
    } else {
      clearInterval(timeChange);
      setBtnDisabled(false);
      setBtnContent('resend');
      setTime(60);
    }
  }, [time]);

  const startFirst = () => {
    setBtnDisabled(true);
    timeChange = setInterval(() => setTime(t => --t), 1000);
  };

  const getPhoneCaptcha = async () => {
    setBtnDisabled(true);
    // 参数
    const params = {
      validateKey,
      key,
    };
    console.log('msgparams', params);
    const pubKey = new NodeRSA(initData.publicKey, 'pkcs8-public');
    const newParams = JSON.parse(JSON.stringify(params));
    pubKey.setOptions({
      encryptionScheme: 'pkcs1',
    }); // 必须得加，要和java加密解密统一
    const encrypted = pubKey.encrypt(newParams, 'base64');
    // 加密后的参数
    const paramsEncrypted = {
      encrypted,
      token: initData.token,
    };
    const res = await qptResend(key, paramsEncrypted);
    const code = res.code;
    if (code === 200000) {
      const { validateKey } = res.data;
      setValidateKey(validateKey);
      // 注意，不要使用 setTime(t-1) ： 闭包问题会导致time一直为59
      timeChange = setInterval(() => setTime(t => --t), 1000);
    } else {
      // 报错情况兼容
      Modal.warning({
        width: isMobileView ? '80%' : '500px',
        centered: true,
        className: isMobileView ? 'h5pc-cashier-error_modal' : '',
        content: `${resCodeMsg(props, code)}`,
        // okText: 'Got It',
        okText: intl.formatMessage({ id: 'ga-checkout.got-it' }),
        onOk() {
          setBtnDisabled(false);
        },
      });
    }
  };

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setLoading(false);
  };

  const onFinishFailed = values => {
    console.log('failed', values);
  };

  /**
   * 支付
   *
   */
  const onFinish = async values => {
    if (_.isEmpty(values)) {
      return;
    }
    // 参数
    const params = {
      ...values,
      validateKey,
      key,
    };
    console.log('params', params);
    const pubKey = new NodeRSA(initData.publicKey, 'pkcs8-public');
    const newParams = JSON.parse(JSON.stringify(params));
    pubKey.setOptions({
      encryptionScheme: 'pkcs1',
    }); // 必须得加，要和java加密解密统一
    const encrypted = pubKey.encrypt(newParams, 'base64');
    // 加密后的参数
    const paramsEncrypted = {
      encrypted,
      token: initData.token,
    };
    console.log('paramsEncrypted', paramsEncrypted);
    setCodeNum(0);
    setBtnLoading(true);
    // setIsModalVisible(false);
    // 请求
    const res = await qptValidate(key, paramsEncrypted);
    const code = res.code;
    if (code === 200000) {
      const { redirectUrl, invoiceId, orderId } = res.data;
      window.location.href = `/success?redirectUrl=${encodeURIComponent(redirectUrl)}&orderId=${orderId}&invoiceId=${invoiceId}`;
    } else if (code === 600005) {
      // (code === 600005)  验证码错误
      // setIsModalVisible(true);
      setBtnLoading(false);
      setCodeNum(code);
    } else {
      setIsModalVisible(false);
      Modal.warning({
        width: isMobileView ? '80%' : '500px',
        centered: true,
        className: isMobileView ? 'h5pc-cashier-error_modal' : '',
        content: `${resCodeMsg(props, code)}`,
        // okText: 'Got It',
        okText: intl.formatMessage({ id: 'ga-checkout.got-it' }),
        onOk() {
          setBtnLoading(false);
          // setIsModalVisible(true);
        },
      });
    }
  };

  const suffixCardNumber = () => {
    const src = `/static/images/bank/ic_${bankCode}.png`;
    return (
      <div className="suffix-card-number">
        {bankCode !== '' ? <img src={src} className="suffix-card-img" /> : null}
      </div>
    );
  };
  const onChangeSMSCode = e => {
    setCodeNum(0);
    if (e.target.value.length > 0) {
      setSubmitBtnDisabled(false);
    } else {
      setSubmitBtnDisabled(true);
    }
  };
  return (
    <div>
      <Modal
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        maskClosable={false}
        // closable={false}
        width="88%"
        centered
        // style={{ maxWidth: '500px' }}
        className="h5pc-message-modal"
        destroyOnClose={true}
        // mask={false}
        forceRender
      >
        <div className="h5pc-message-modal-container">
          <div className="payment-card-number">
            Payment card：
            <span>{cardNo} </span>
            {suffixCardNumber()}
          </div>
          <div className="payment-amount">
            Amount:
            <span className="payment-amount-value1">
              {myActualPaymentCurrencySymbol} {myActualPaymentAmount}
            </span>
            <span className="payment-amount-value2">
              (= {totalCurrencySymbol} {totalAmount})
            </span>
          </div>
          <Form
            form={form}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            requiredMark={false}
            layout="vertical"
            scrollToFirstError
          >
            <Row gutter={20}>
              <Col span={24}>
                <Button
                  // type="primary"
                  disabled={btnDisabled}
                  onClick={getPhoneCaptcha}
                  type="link"
                  className="send-btn"
                >
                  {btnContent}
                </Button>
                <FloatLabel
                  form={form}
                  name="captcha"
                  label="SMS"
                  className="ant-form-item-required"
                  rules={[
                    {
                      required: true,
                      message: `Please enter verification code(输入验证码)`,
                    },
                    {
                      pattern: /^\d+$/,
                      message: 'Please enter verification code(输入验证码)',
                    },
                  ]}
                  getValueFromEvent={e => {
                    let val = e.target.value;
                    let newVal = val.replace(/[^0-9]/gi, ''); // 替换字符串中的所有的非数字
                    e.target.value = newVal;
                    return e.target.value;
                  }}
                >
                  <Input
                    size="large"
                    type="tel"
                    maxLength={6}
                    onChange={e => onChangeSMSCode(e)}
                  />
                </FloatLabel>
              </Col>
            </Row>
            {codeNum === 600005 ? (
              <div className="error-code-container">
                Incorrect code. Please try again <br />
                验证码错误,请重新输入
              </div>
            ) : (
              ''
            )}
            <div className="sms-verification-conatiner">
              * Verification code sent to your phone: {phoneNum} (输入验证码)
            </div>
            <div className="submit-btn-container">
              <Button
                type="primary"
                htmlType="submit"
                loading={btnLoading}
                disabled={submitBtnDisabled}
                className="submit-btn"
              >
                Confirm
              </Button>
            </div>
          </Form>
        </div>
      </Modal>
    </div>
  );
}

export default injectIntl(MessageModal);
